import { observer } from 'mobx-react';
import SchoolPartnerLogo from '../SchoolPartnerLogo';
import { Link } from '../../../../../../Resource/Types';
import { cn } from '@execonline-inc/execonline-ui';

interface Props {
  className?: string;
  name: string;
  height: number;
  links: ReadonlyArray<Link>;
}

function ExperienceViewLogo({ height, name, className, links }: Props) {
  return (
    <div
      className={cn(
        'box-border flex h-full w-full items-center justify-center bg-muted p-2',
        className,
      )}
    >
      <SchoolPartnerLogo height={height} name={name} links={links} />
    </div>
  );
}

export default observer(ExperienceViewLogo);
